import PropTypes from 'prop-types';
import React, { Component } from 'react';
import zenScroll from 'zenscroll';
import { sendAnalyticsEvent } from '../../../utils/analytics';

export default class AnchorNavItem extends Component {
  scrollToAnchor = (event) => {
    event.preventDefault();
    sendAnalyticsEvent(
      'Chapter Links',
      'Click',
      this.props.name
    );
    const el = document.querySelector(`[name="${this.props.name}"]`);
    const top = el.getBoundingClientRect().top;
    const bodyTop = document.body.getBoundingClientRect().top;
    const position = top - bodyTop - 150;
    zenScroll.toY(position);
  };

  render() {
    return (
      <li className="anchor-link" onClick={this.scrollToAnchor}>
        {this.props.name}
      </li>
    );
  }
}

AnchorNavItem.propTypes = {
  name: PropTypes.string
};
